

















import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import "./mobile-gallery.less";
import "slick-carousel";
import BadgesComponent from "@/components/badges/badges.vue";

@Component({
  components: {
    BadgesComponent
  }
})
export default class MobileGallery extends Vue {
  @Prop() images;
  @Prop() visible;
  @Prop() project;

  private data = {
    visible: true
  };

  imgRatio = 16 / 9;

  mounted() {
    $('.project-mobile-gallery').height(($('.project-mobile-gallery').width())! * 9 / 16);
    this.data.visible = this.visible;
  }
  updated() {
    this.data.visible = this.visible;
  }

  getBadgesData() {
    return {
      nominee: this.project!.life_challenge_nominee,
      winner: this.project!.life_challenge_winner,
      total_winner: this.project!.life_challenge_total_winner,
      public_winner: this.project!.life_challenge_public_winner
    };
  }

  @Watch("visible", { immediate: true, deep: true })
  onVisible(visible) {
    let self = this;
    this.data.visible = visible;
    if (visible) {
      setTimeout(function() {
        self.initCarusel();
      }, 200);
    } else {
      this.destroyCarusel();
    }
  }

  trans(key) {
    return translate(key);
  }

  refreshCarusel() {
    this.destroyCarusel();
    this.initCarusel();
  }

  closeModal() {
    this.data.visible = false;
    this.onShowModalGallery(0, false);
    this.destroyCarusel();
  }

  galleryResize() {
    var width = window.innerWidth;
    var height = window.innerHeight;

    $(".mobile-gallery-image-container").height((width/16) * 9);
    setTimeout(()=>{
      $(".mobile-gallery-slick-slider-list").height((width/16) * 9);
    }, 1000)

    /*if (width >= 960) {
     $(".mobile-gallery-image-container").height(height - 160);
    } else if (width >= 600 && width <= 959) {
      //$(".mobile-gallery-image-container").height(height - 120);
    } else if (width <= 599) {
      //$(".mobile-gallery-image-container").height(height - 60);
    }*/
  }

  initCarusel() {
    try {
      ($(".mobile-gallery-slick-slider-list") as any).slick({
        infinite: true,
        centerMode: false,
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: "ondemand",
        prevArrow:
          '<a class="carousel-control-prev gallery-button" href="" role="button" data-slide="prev"><span class="mdi mdi-chevron-left"></span></a>',
        nextArrow:
          '<a class="carousel-control-next gallery-button" href="" role="button" data-slide="next"><span class="mdi mdi-chevron-right"></span></a>',
        dots: true,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });
      // this.galleryResize();
    } catch (ex) {}
    try {
      // window.addEventListener('resize', this.galleryResize);
      // window.addEventListener('orientationchange', this.galleryResize);
    } catch (e) {}
  }

  destroyCarusel() {
    try {
      ($(".mobile-gallery-slick-slider-list") as any).slick("destroy");
    } catch (ex) {}
  }

  loaded(ev) {

    const img = $(ev.target);
    if (img.length) {
      img
              .eq(0)
              .addClass(
                      img.get(0).naturalWidth! / img.get(0).naturalHeight! < this.imgRatio
                              ? "narrow"
                              : "wide"
              );
    }
  }

  @Emit("showModalGallery")
  onShowModalGallery(index, visible) {
    console.log(index, visible)
  }

}
